export interface CodeSet
{
    id?: number;
    version?: number;
    name?: string;
    description?: string;
    codeSetVersion?: string;
}

export class Dictionary
{
    public id: number;
    public version: number;
    public code: string;
    public displayName: string;
    public codeSetId: number;
    public codeSet: CodeSet;
    public codeSystem: string;
    public alternateCode: string;
    public codeSetPerRecord: any;
}

export interface Code
{
    id?: number;
    version?: number;
    code: string;
    displayName: string;
    codeSet: CodeSet;
    codeSystem: string;
    alternateCode: string;
}

export interface CodeLanguage
{
    id?: number;
    version?: number;
    displayName: string;
    language: CodeSet;
}
